import styled  from 'styled-components';

export const FeaturesContainer = styled.div`
    margin-top: 24px;
    flex: 0 1 auto;
    display: flex;
    flex-wrap: wrap;
    row-gap: 32px;
    column-gap: 28px;
    width: 100%;
    height: 100%;
    z-index: 1;
`;

export const FeatureRow = styled.div`
    display: flex;
    gap: 28px;
`;

export const FeatureContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: nowrap;
`;

export const FeatureIcon = styled.i`
    margin-right: 8px;
`;
